import { useState, useEffect } from "react"
import { Box } from "theme-ui"
import { useTranslation } from "react-i18next"
//Accordion
import {
 Accordion,
 AccordionItem,
 AccordionItemHeading,
 AccordionItemButton,
 AccordionItemPanel,
} from "react-accessible-accordion"
import "react-accessible-accordion/dist/fancy-example.css"
import { MyTableComponent, Button, Input } from "components"
import { useSettingsUserManagementQuery } from "../../store/Features/settings/settingsUserManagement-api-slice"

import Plus from "./plus.svg"
// import { IUserManagement } from "@types"
export const UserManagement = () => {
 // language translator
 const { t } = useTranslation("translation")
 const { data } = useSettingsUserManagementQuery()

 //  const [allData, setAllData] = useState<IUserManagement[]>([])
 const [userGroup, setUserGroup] = useState<any[]>([])
 const [selectedUserData, setSelectedUserData] = useState<any>()
 const [popup, setPopup] = useState<boolean>(false)
 const [active, setActive] = useState<number | null>()

 const columns = [
  { Header: "Name", accessor: "group_name" },
  {
   Header: t("action"),
   Cell: ({ row }: any) => (
    <div className="flex">
     <div className="mr-2">
      <Button
       size={"tableSmallSize"}
       color={"darkBrown"}
       onClick={() => {
        setPopup(true)
        setSelectedUserData(
         userGroup && userGroup?.find((item: any, index: number) => index === Number(row?.id)),
        )
       }}
      >
       {t("edit")}
      </Button>
     </div>
     <div>
      <Button size={"tableSmallSize"} color={"pink"}>
       {t("delete")}
      </Button>
     </div>
    </div>
   ),
  },
 ]
 useEffect(() => {
  if (data) {
   //  setAllData(data)

   setUserGroup(
    data
     .map((single) => {
      return single?.user_groups
     })
     .flat(),
   )
  }
 }, [data])

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   {popup && (
    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
     <div className="fixed inset-0 z-10 w-screen h-screen bg-black bg-opacity-50 overflow-y-scroll">
      <div className="flex h-screen items-end justify-center p-4 text-center sm:items-center sm:p-0">
       <Box
        bg="highlight"
        className="relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:w-full sm:max-w-5xl h-[75vh] pb-5 "
       >
        <div className="flex justify-between items-center bg-golden px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
         <div className="sm:flex font-bold sm:items-start ">Edit user group</div>
         <div>
          <Button
           size={"sm"}
           color={"white"}
           onClick={() => {
            setPopup(false)
           }}
          >
           Close
          </Button>
         </div>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:px-4 overflow-y-scroll h-[65vh]">
         <div className="flex flex-wrap gap-5 justify-between">
          <div className="w-[46%]">
           <div className="flex flex-col">
            <label htmlFor="group-name" className="me-2 text-base font-semibold text-black">
             Group name:
            </label>
            <Input
             id="group-name"
             className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2 placeholder:text-black"
             placeholder="Administration"
             type="text"
             onChange={(value: any) => {
              setSelectedUserData((prevData: any) => ({
               ...prevData,
               group_name: value,
              }))
             }}
             value={selectedUserData?.group_name}
            />
           </div>
           <Accordion
            onChange={(event) => {
             const _event = event[0] as string
             const r = /\d+/
             const _active = _event ? +_event.match(r)! : null
             setActive(_active)
            }}
            allowZeroExpanded={true}
            className="mb-[22px] md:mb-2.5 lg:mb-[22px]"
           >
            <AccordionItem className="">
             <AccordionItemHeading>
              <AccordionItemButton
               className={`flex items-center justify-between py-2.5 px-4 text-base text-theme-Darkblue font-extrabold bg-gray 2xl:text-lg`}
              >
               <div className="flex items-center ">
                {active === 3 ? (
                 <svg
                  className="h-[12px] w-[12px] mr-6 md:mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                 >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                 </svg>
                ) : (
                 <img src={Plus} alt="Open" className="h-[12px] w-[12px] mr-6 md:mr-3" />
                )}

                <p className="text-base font-semibold">{"Name"}</p>
               </div>

               <div className="custom-checkbox">
                <input type="checkbox" id="group" />
                <label className="font-semibold font-sm Jakarta-font" htmlFor="group">
                 All
                </label>
               </div>
              </AccordionItemButton>
             </AccordionItemHeading>
             <AccordionItemPanel className="accordion-panel text-theme-Darkblue bg-white border border-t-0 border-b-2 border-light-gray rounded-b-md">
              <div className="flex justify-between items-center py-2.5 px-4">
               <div className="inline-block relative w-[55%]">
                <select className="block appearance-none w-full bg-white border-light-gray border-[1.5px] px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline">
                 {selectedUserData &&
                  selectedUserData?.users.map((item: any, index: number) => (
                   <option selected value="option1" key={index}>
                    {item?.user_name}
                   </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                 <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                 >
                  <path d="M10 12l-6-6 1.41-1.41L10 9.17l4.59-4.58L16 6z" />
                 </svg>
                </div>
               </div>
               <div className="w-1/5">
                <Button size={"lg"}>Add</Button>
               </div>
               <div className="w-1/5">
                <Button size={"lg"}>New</Button>
               </div>
              </div>
             </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem className="mt-5">
             <AccordionItemHeading>
              <AccordionItemButton
               className={`flex items-center justify-between py-2.5 px-4 text-base text-theme-Darkblue font-extrabold bg-gray 2xl:text-lg`}
              >
               <div className="flex items-center ">
                {active === 5 ? (
                 <svg
                  className="h-[12px] w-[12px] mr-6 md:mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                 >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                 </svg>
                ) : (
                 <img src={Plus} alt="Open" className="h-[12px] w-[12px] mr-6 md:mr-3" />
                )}
                <p className="text-base font-semibold">{"Device rights"}</p>
               </div>

               <div className="custom-checkbox">
                <input
                 type="checkbox"
                 id="deviceRight"
                 onChange={(e: any) => {
                  const isChecked = e.target.checked
                  if (isChecked) {
                   if (selectedUserData && selectedUserData.device_rights) {
                    // Set all checkboxes to checked
                    const updatedCheckboxes = selectedUserData.device_rights.map(
                     (checkbox: any) => ({
                      ...checkbox,
                      device_right_allowed: true,
                     }),
                    )
                    setSelectedUserData((prevData: any) => ({
                     ...prevData,
                     device_rights: updatedCheckboxes,
                    }))
                   }
                  } else {
                   // Unset all checkboxes
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    device_rights: selectedUserData.device_rights.map((deviceRight: any) => ({
                     ...deviceRight,
                     device_right_allowed: false,
                    })),
                   }))
                  }
                 }}
                 checked={
                  selectedUserData.device_rights &&
                  selectedUserData.device_rights.every(
                   (checkbox: any) => checkbox.device_right_allowed,
                  )
                 }
                />
                <label className="font-semibold font-sm Jakarta-font" htmlFor="deviceRight">
                 All
                </label>
               </div>
              </AccordionItemButton>
             </AccordionItemHeading>
             <AccordionItemPanel className="accordion-panel text-theme-Darkblue bg-white border border-t-0 border-b-2 border-light-gray rounded-b-md">
              {selectedUserData &&
               selectedUserData?.device_rights?.map((item: any, index: number) => (
                <div
                 key={index}
                 className="custom-checkbox2 relative flex justify-between items-center px-4 py-2.5"
                >
                 <input
                  type="checkbox"
                  id={`deviceRight${index}`}
                  className="visually-hidden "
                  onChange={(e) => {
                   const isChecked = e.target.checked
                   setSelectedUserData((prevData: any) => {
                    const updatedDeviceRights = prevData.device_rights.map(
                     (deviceRight: any, i: number) => ({
                      ...deviceRight,
                      device_right_allowed:
                       i === index ? isChecked : deviceRight.device_right_allowed,
                     }),
                    )

                    return {
                     ...prevData,
                     device_rights: updatedDeviceRights,
                    }
                   })
                  }}
                  checked={item?.device_right_allowed}
                 />
                 <label
                  className="font-semibold font-sm Jakarta-font cursor-pointer"
                  htmlFor={`deviceRight${index}`}
                 >
                  {item?.device_name}
                 </label>
                </div>
               ))}
             </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem className="mt-5">
             <AccordionItemHeading>
              <AccordionItemButton
               className={`flex items-center justify-between py-2.5 px-4 text-base text-theme-Darkblue font-extrabold bg-gray 2xl:text-lg`}
              >
               <div className="flex items-center ">
                {active === 7 ? (
                 <svg
                  className="h-[12px] w-[12px] mr-6 md:mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                 >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                 </svg>
                ) : (
                 <img src={Plus} alt="Open" className="h-[12px] w-[12px] mr-6 md:mr-3" />
                )}
                <p className="text-base font-semibold">{"Message permissions"}</p>
               </div>

               <div className="custom-checkbox">
                <input
                 type="checkbox"
                 id="messagePermissions"
                 onChange={(e) => {
                  if (e.target.checked) {
                   if (selectedUserData?.message_permissions) {
                    const checkboxMessagePermission = selectedUserData?.message_permissions?.map(
                     (messagePermission: any) => ({
                      ...messagePermission,
                      message_permission_allowed: true,
                     }),
                    )
                    setSelectedUserData((prevData: any) => ({
                     ...prevData,
                     message_permissions: checkboxMessagePermission,
                    }))
                   }
                  } else {
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    message_permissions: prevData?.message_permissions.map(
                     (messagePermission: any) => ({
                      ...messagePermission,
                      message_permission_allowed: false,
                     }),
                    ),
                   }))
                  }
                 }}
                 checked={
                  selectedUserData.message_permissions &&
                  selectedUserData.message_permissions.every(
                   (checkbox: any) => checkbox.message_permission_allowed,
                  )
                 }
                />
                <label className="font-semibold font-sm Jakarta-font" htmlFor="messagePermissions">
                 All
                </label>
               </div>
              </AccordionItemButton>
             </AccordionItemHeading>
             <AccordionItemPanel className="accordion-panel text-theme-Darkblue bg-white border border-t-0 border-b-2 border-light-gray rounded-b-md">
              <div className="">
               {selectedUserData &&
                selectedUserData?.message_permissions.map((item: any, index: number) => (
                 <div
                  key={index}
                  className="custom-checkbox2 relative flex justify-between items-center px-4 py-2.5"
                 >
                  <input
                   type="checkbox"
                   id={`messagePermissions${index}`}
                   className="visually-hidden"
                   onChange={(e) => {
                    const isChecked = e.target.checked
                    setSelectedUserData((prevData: any) => {
                     const updatedMessagePermission = prevData?.message_permissions.map(
                      (messagePermission: any, i: any) => ({
                       ...messagePermission,
                       message_permission_allowed:
                        i === index ? isChecked : messagePermission?.message_permission_allowed,
                      }),
                     )
                     return {
                      ...prevData,
                      message_permissions: updatedMessagePermission,
                     }
                    })
                   }}
                   checked={item?.message_permission_allowed}
                  />
                  <label
                   className="font-semibold font-sm Jakarta-font cursor-pointer"
                   htmlFor={`messagePermissions${index}`}
                  >
                   {item?.message_description}
                  </label>
                 </div>
                ))}
              </div>
             </AccordionItemPanel>
            </AccordionItem>
           </Accordion>
          </div>
          <div className="w-[46%]">
           <div className="flex flex-col">
            <label htmlFor="description" className="me-2 text-base font-semibold text-black">
             Description:
            </label>
            <Input
             id="description"
             className="outline-none text-black border-light-gray border-[1.5px] h-8 rounded  pl-2 placeholder:text-black"
             placeholder="Administration"
             type="text"
             onChange={(value: any) => {
              setSelectedUserData((prevData: any) => ({
               ...prevData,
               group_description: value,
              }))
             }}
             value={selectedUserData?.group_description}
            />
           </div>
           <Accordion
            onChange={(event) => {
             const _event = event[0] as string
             const r = /\d+/
             const _active = _event ? +_event.match(r)! : null
             setActive(_active)
            }}
            allowZeroExpanded={true}
            className="mb-[22px] md:mb-2.5 lg:mb-[22px]"
           >
            <AccordionItem className="">
             <AccordionItemHeading>
              <AccordionItemButton
               className={`flex items-center justify-between py-2.5 px-4 text-base text-theme-Darkblue font-extrabold bg-gray 2xl:text-lg`}
              >
               <div className="flex items-center ">
                {active === 9 ? (
                 <svg
                  className="h-[12px] w-[12px] mr-6 md:mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                 >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                 </svg>
                ) : (
                 <img src={Plus} alt="Open" className="h-[12px] w-[12px] mr-6 md:mr-3" />
                )}
                <p className="text-base font-semibold">{"Module Rights"}</p>
               </div>

               <div className="custom-checkbox">
                <input
                 type="checkbox"
                 id="descriptionFor"
                 onChange={(e) => {
                  if (e.target.checked) {
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    module_rights: prevData?.module_rights?.map((moduleRight: any) => ({
                     ...moduleRight,
                     module_right_allowed: true,
                    })),
                   }))
                  } else {
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    module_rights: prevData.module_rights.map((moduleRight: any) => ({
                     ...moduleRight,
                     module_right_allowed: false,
                    })),
                   }))
                  }
                 }}
                 checked={
                  selectedUserData.module_rights &&
                  selectedUserData?.module_rights.every(
                   (checkbox: any) => checkbox.module_right_allowed,
                  )
                 }
                />
                <label className="font-semibold font-sm Jakarta-font" htmlFor="descriptionFor">
                 All
                </label>
               </div>
              </AccordionItemButton>
             </AccordionItemHeading>
             <AccordionItemPanel className="accordion-panel text-theme-Darkblue bg-white border border-t-0 border-b-2 border-light-gray rounded-b-md">
              <div className="">
               {selectedUserData &&
                selectedUserData?.module_rights.map((item: any, index: number) => (
                 <div
                  key={index}
                  className="custom-checkbox2 relative flex justify-between items-center px-4 py-2.5"
                 >
                  <input
                   type="checkbox"
                   id={`description${index}`}
                   className="visually-hidden"
                   onClick={(e: any) => {
                    const isChecked = e.target.checked
                    setSelectedUserData((prevData: any) => ({
                     ...prevData,
                     module_rights: prevData?.module_rights?.map(
                      (moduleRights: any, i: number) => ({
                       ...moduleRights,
                       module_right_allowed:
                        i === index ? isChecked : moduleRights?.module_right_allowed,
                      }),
                     ),
                    }))
                   }}
                   checked={item?.module_right_allowed}
                  />
                  <label
                   className="font-semibold font-sm Jakarta-font cursor-pointer"
                   htmlFor={`description${index}`}
                  >
                   {item?.module_right_name}
                  </label>
                 </div>
                ))}
              </div>
             </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem className="mt-5">
             <AccordionItemHeading>
              <AccordionItemButton
               className={`flex items-center justify-between py-2.5 px-4 text-base text-theme-Darkblue font-extrabold bg-gray 2xl:text-lg`}
              >
               <div className="flex items-center ">
                {active === 0 ? (
                 <svg
                  className="h-[12px] w-[12px] mr-6 md:mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                 >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                 </svg>
                ) : (
                 <img src={Plus} alt="Open" className="h-[12px] w-[12px] mr-6 md:mr-3" />
                )}
                <p className="text-base font-semibold">{"Device group rights"}</p>
               </div>
               <div className="custom-checkbox">
                <input
                 type="checkbox"
                 id="deviceGroupRight"
                 onChange={(e) => {
                  if (e.target.checked) {
                   const updatedCheckbox = selectedUserData?.device_group_rights?.map(
                    (deviceGroupRight: any) => ({
                     ...deviceGroupRight,
                     device_group_right_allowed: true,
                    }),
                   )
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    device_group_rights: updatedCheckbox,
                   }))
                  } else {
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    device_group_rights: prevData.device_group_rights.map(
                     (deviceGroupRights: any) => ({
                      ...deviceGroupRights,
                      device_group_right_allowed: false,
                     }),
                    ),
                   }))
                  }
                 }}
                 checked={
                  selectedUserData?.device_group_rights &&
                  selectedUserData.device_group_rights.every(
                   (checkbox: any) => checkbox.device_group_right_allowed,
                  )
                 }
                />
                <label className="font-semibold font-sm Jakarta-font" htmlFor="deviceGroupRight">
                 All
                </label>
               </div>
              </AccordionItemButton>
             </AccordionItemHeading>
             <AccordionItemPanel className="accordion-panel text-theme-Darkblue bg-white border border-t-0 border-b-2 border-light-gray rounded-b-md">
              <div className="">
               {selectedUserData &&
                selectedUserData?.device_group_rights?.map((item: any, index: number) => (
                 <div
                  key={index}
                  className="custom-checkbox2 relative flex justify-between items-center px-4 py-2.5"
                 >
                  <input
                   type="checkbox"
                   id={`deviceGroupRight${index}`}
                   className="visually-hidden"
                   onChange={(e) => {
                    const isChecked = e.target.checked
                    setSelectedUserData((prevData: any) => {
                     const updatedDeviceGroupRight = prevData?.device_group_rights?.map(
                      (deviceGroupRight: any, i: number) => ({
                       ...deviceGroupRight,
                       device_group_right_allowed:
                        i === index ? isChecked : deviceGroupRight?.device_group_right_allowed,
                      }),
                     )
                     return {
                      ...prevData,
                      device_group_rights: updatedDeviceGroupRight,
                     }
                    })
                   }}
                   checked={item?.device_group_right_allowed}
                  />
                  <label
                   className="font-semibold font-sm Jakarta-font cursor-pointer"
                   htmlFor={`deviceGroupRight${index}`}
                  >
                   {item?.device_group_name}
                  </label>
                 </div>
                ))}
              </div>
             </AccordionItemPanel>
            </AccordionItem>

            <AccordionItem className="mt-5">
             <AccordionItemHeading>
              <AccordionItemButton
               className={`flex items-center justify-between py-2.5 px-4 text-base text-theme-Darkblue font-extrabold bg-gray 2xl:text-lg`}
              >
               <div className="flex items-center ">
                {active === 0 ? (
                 <svg
                  className="h-[12px] w-[12px] mr-6 md:mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                 >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                 </svg>
                ) : (
                 <img src={Plus} alt="Open" className="h-[12px] w-[12px] mr-6 md:mr-3" />
                )}
                <p className="text-base font-semibold">{"Device group permissions"}</p>
               </div>

               <div className="custom-checkbox">
                <input
                 type="checkbox"
                 id="deviceGroupPermissions"
                 onChange={(e) => {
                  if (e.target.checked) {
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    message_group_permissions: prevData?.message_group_permissions?.map(
                     (messageGroupPermission: any) => ({
                      ...messageGroupPermission,
                      message_group_allowed: true,
                     }),
                    ),
                   }))
                  } else {
                   setSelectedUserData((prevData: any) => ({
                    ...prevData,
                    message_group_permissions: prevData?.message_group_permissions.map(
                     (messageGroupPermissions: any) => ({
                      ...messageGroupPermissions,
                      message_group_allowed: false,
                     }),
                    ),
                   }))
                  }
                 }}
                 checked={
                  selectedUserData?.message_group_permissions &&
                  selectedUserData?.message_group_permissions.every(
                   (checkbox: any) => checkbox.message_group_allowed,
                  )
                 }
                />
                <label
                 className="font-semibold font-sm Jakarta-font"
                 htmlFor="deviceGroupPermissions"
                >
                 All
                </label>
               </div>
              </AccordionItemButton>
             </AccordionItemHeading>
             <AccordionItemPanel className="accordion-panel text-theme-Darkblue bg-white border border-t-0 border-b-2 border-light-gray rounded-b-md">
              <div className="">
               {selectedUserData &&
                selectedUserData?.message_group_permissions.map((item: any, index: number) => (
                 <div
                  key={index}
                  className="custom-checkbox2 relative flex justify-between items-center px-4 py-2.5"
                 >
                  <input
                   type="checkbox"
                   id={`deviceGroupPermissions${index}`}
                   className="visually-hidden"
                   onChange={(e) => {
                    const isChecked = e.target.checked
                    setSelectedUserData((prevData: any) => {
                     const updatedMessageGroupPermissions = prevData?.message_group_permissions.map(
                      (messageGroupPermission: any, i: number) => ({
                       ...messageGroupPermission,
                       message_group_allowed:
                        i === index ? isChecked : messageGroupPermission?.message_group_allowed,
                      }),
                     )
                     return {
                      ...prevData,
                      message_group_permissions: updatedMessageGroupPermissions,
                     }
                    })
                   }}
                   checked={item?.message_group_allowed}
                  />
                  <label
                   className="font-semibold font-sm Jakarta-font cursor-pointer"
                   htmlFor={`deviceGroupPermissions${index}`}
                  >
                   {item?.message_group_name}
                  </label>
                 </div>
                ))}
              </div>
             </AccordionItemPanel>
            </AccordionItem>
           </Accordion>
          </div>
         </div>
        </div>
       </Box>
      </div>
     </div>
    </div>
   )}
   <div className="pt-6">
    <Box bg="highlight" className="flex lg:flex-row flex-col lg:justify-between lg:items-center py-4 px-2">
     <h1 className="Jakarta-font font-bold text-xl">Benutzergruppen</h1>
     <div className="flex lg:items-center lg:flex-row flex-col">
      <div className="lg:mr-2">
       <Button size={"doublexl"}>Forum Gera</Button>
      </div>
      <Box bg="text" className="rounded py-2">
       <Button size={"doublexl"} color={"gray"}>
        Test Server
       </Button>
      </Box>
     </div>
    </Box>
   </div>

   {/* ====== TableComponent ====== */}
   <MyTableComponent
    fullHeight={false}
    columns={columns}
    data={data ? userGroup : []}
    paginate={true}
   />
  </div>
 )
}
